import React from 'react';
import { Row, Col, Card, CardBody, Button, Modal } from 'reactstrap';
import Loader from '../../shared/loader/loader';

const ShowImageModal = (props) => {
  const {
    modalOpen,
    selectedImage,
    toggleModal,
    loader,
  } = props;


  return (
    <Modal
      isOpen={modalOpen}
      toggle={() => {
        toggleModal();
      }}
    >
      <Card>
        <CardBody>
          <Loader loading={loader} />
          <Row>
            <Col md="12">
              <h5>Attachment</h5>
            </Col>
            <Col md="12">
              <img src={selectedImage} alt="marking scheme" className="img-fluid" />
            </Col>
            <Col md="12" className="mt-4">
              <Row className="justify-content-center">
                <Button
                  type="button"
                  onClick={() => {
                    toggleModal();
                  }}
                  className="agora-button cancel-button border-radius"
                >
                  Close
                </Button>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Modal>
  );
};

export default ShowImageModal;
